import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const FieldInput = ({ isValid, placeholder, showPlaceholder, name, register }) => {
    return (_jsx("input", { id: name, placeholder: placeholder, className: `form-control ${!isValid ? 'is-invalid' : ''} ${showPlaceholder ? 'show-placeholder' : ''}`, ...register }));
};
export default FieldInput;
